import { defaultBackgroundIcon, iconColorOptions, PresetIconColor } from "@/modules/policies/policies.const";
import { Popover, PopoverTrigger, PopoverContent } from "components/ui/popover";
import { useMemo } from "react";
import clsx from "clsx";
import { IconColor as EIconColor } from "types/gql/graphql";

import { Tooltip } from "./tooltip";

interface IconColorProps {
  value?: EIconColor;
  onChange: (title: string) => void;
  className?: string;
  popoverClassName?: string;
  presetColors?: Record<string, string>;
}

export const IconColor = ({
  onChange,
  className,
  popoverClassName,
  presetColors = iconColorOptions,
  value,
}: IconColorProps) => {
  const handleSelectColor = (value: string) => {
    onChange(value);
  };

  const presetIconColors: PresetIconColor[] = Object.entries(presetColors).map(([key, value]) => ({
    label: key,
    color: value,
  }));

  const backgroundColor = useMemo(() => {
    if (value) {
      return iconColorOptions[value] ?? defaultBackgroundIcon;
    }
    return defaultBackgroundIcon;
  }, [value]);

  return (
    <Popover>
      <PopoverTrigger
        className={clsx("relative text-sm border border-primary rounded-sm w-20 h-8 text-primary", className)}
        style={{ backgroundColor }}
      >
        {value ? "" : "None"}
      </PopoverTrigger>

      <PopoverContent className={clsx("absolute bg-default", popoverClassName)}>
        <div className="grid grid-cols-4 gap-2 py-2 pl-3">
          {presetIconColors?.map((preset) => (
            <Tooltip label={preset.label} offset={0} key={`color-picker-${preset.label}`}>
              <button
                className="w-8 h-6 rounded-sm border border-primary"
                style={{ backgroundColor: preset.color }}
                onClick={() => handleSelectColor(preset.label)}
                type="button"
              />
            </Tooltip>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
